import { v4 } from 'uuid';

/** Creates a unique id. */
export function id(): string {
  return v4();
}
